import { runInAction } from "mobx";

import { useStore } from "@/store/RootStoreProvider";
import { TeamChatsStore } from "@/store/TeamChatsStore";

export function useTeamChats(): TeamChatsStore {
  const rootStore = useStore();

  if (!rootStore.teamChats) {
    runInAction(() => {
      if (!rootStore.teamChats) {
        rootStore.teamChats = new TeamChatsStore(rootStore);
      }
    });
  }

  return rootStore.teamChats!;
}
